import { useNavigate } from 'react-router-dom';

const footerLinks = {
  rooms: { title: '房型选择', items: ['豪华大床房', '尊贵套房', '总统套房', '家庭套房', '行政客房', '海景套房'] },
  dining: { title: '餐厅美食', items: ['天巢法国餐厅', '8餐厅', '新葡京自助餐', '大堂酒廊', '池畔吧'] },
  guide: { title: '入住攻略', items: ['预订指南', '交通攻略', '周边景点', '设施介绍', '常见问题'] },
  about: { title: '关于我们', items: ['品牌介绍', '口碑评价', '联系方式', '加入我们', '隐私政策'] },
};

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-background-950">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-hotel-line text-background-50 text-lg"></i>
              </div>
              <div>
                <span className="font-heading text-base font-semibold text-background-50">新葡京酒店</span>
              </div>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              澳门地标级豪华酒店<br />极致奢华住宿体验
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200">
                <i className="ri-instagram-line text-sm"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([key, section]) => (
            <div key={key}>
              <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">{section.title}</h4>
              <ul className="space-y-2.5">
                {section.items.map((item) => (
                  <li key={item}>
                    <button
                      onClick={() => navigate(`/category/${key === 'guide' ? 'articles' : key === 'about' ? 'about' : key}`)}
                      className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {item}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2007-2026 新葡京酒店 Grand Lisboa Hotel. 版权所有.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200">使用条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}